import { useTeamDoc } from './useTeamDoc';

/**
 * The team document, or null until it arrives.
 *
 * Backed by the shared per-team subscription, so this and the access guard read
 * one listener between them rather than opening one each.
 */
export function useTeamDetails(teamId) {
    return useTeamDoc(teamId).team;
}
